import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { sendForm } from '../lib/sendEmail';

const CARDS = [
  {
    title: 'Customer Support',
    body: 'Our support team is available to help with any questions or technical issues.',
  },
  {
    title: 'Feedback & Suggestions',
    body: 'We value your feedback and continuously improve our products through user insights.',
  },
  {
    title: 'Research & Media',
    body: 'For collaborations or media inquiries, reach out to our team.',
  },
];

export default function Contact() {
  const [form, setForm] = useState({ first: '', last: '', email: '', phone: '', message: '' });
  const [status, setStatus] = useState({ state: 'idle', message: '' }); // idle | sending | success | error
  const handle = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setStatus({ state: 'sending', message: '' });
    const res = await sendForm({
      subject: `Contact form — ${form.first} ${form.last}`.trim(),
      fields: {
        'First name': form.first,
        'Last name': form.last,
        Email: form.email,
        Phone: form.phone,
        Message: form.message,
      },
    });
    if (res.ok) {
      setStatus({ state: 'success', message: res.message });
      setForm({ first: '', last: '', email: '', phone: '', message: '' });
    } else {
      setStatus({ state: 'error', message: res.message });
    }
  };

  return (
    <>
      <section className="px-6 pt-12 pb-16 md:pt-20 md:pb-20 background-grid">
        <div className="max-w-5xl mx-auto">
          <span className="text-xs uppercase tracking-[0.3em] text-gray-500">Contact</span>
          <h1 className="text-4xl md:text-6xl font-light mt-4 mb-6 leading-tight">
            Get in touch.
          </h1>
          <div className="w-24 h-px bg-gray-900 mb-8" />
          <p className="text-lg text-gray-700 leading-relaxed max-w-2xl">
            For general inquiries, partnerships, and media. We reply within 24 hours.
            Looking for Bloora early access?{' '}
            <Link to="/early-access" className="underline">Apply here →</Link>
          </p>
        </div>
      </section>

      <section className="px-6 pb-24 md:pb-32" style={{ backgroundColor: '#f5f6ed' }}>
        <div className="max-w-5xl mx-auto pt-16 grid lg:grid-cols-2 gap-12">
          <div>
            <h2 className="text-3xl font-light mb-6">Reach us directly</h2>
            <div className="space-y-3 text-gray-800 mb-10">
              <p><span className="text-gray-500 mr-2">Email</span> cognitics.research@gmail.com</p>
              <p><span className="text-gray-500 mr-2">Phone</span> +91 6005748700</p>
              <p><span className="text-gray-500 mr-2">Phone</span> +91 7889929416</p>
            </div>

            <div className="grid sm:grid-cols-3 gap-4">
              {CARDS.map((c) => (
                <div
                  key={c.title}
                  className="border border-gray-200 rounded-xl p-5 hover:shadow-md transition-all duration-300"
                  style={{ backgroundColor: '#fbfcf3' }}
                >
                  <h4 className="font-medium mb-2 text-sm">{c.title}</h4>
                  <p className="text-xs text-gray-600 leading-relaxed">{c.body}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="p-10 border border-gray-200 rounded-2xl" style={{ backgroundColor: '#fbfcf3' }}>
            <h3 className="text-2xl font-light mb-1">Send a message</h3>
            <p className="text-sm text-gray-500 mb-8">You can reach us anytime.</p>

            {status.state === 'success' ? (
              <div className="text-left">
                <span className="text-xs uppercase tracking-[0.3em] text-gray-500">Sent</span>
                <h4 className="text-2xl font-light mt-3 mb-3">Thanks — we'll be in touch.</h4>
                <div className="w-12 h-px bg-gray-900 mb-6" />
                <p className="text-gray-700 leading-relaxed mb-6">
                  Your message reached us. We reply within 24 hours.
                </p>
                <button type="button" onClick={() => setStatus({ state: 'idle', message: '' })} className="btn-ghost">
                  Send another
                </button>
              </div>
            ) : (
              <form onSubmit={submit} className="space-y-5">
                <div className="grid grid-cols-2 gap-4">
                  <input type="text" placeholder="First name" className="input" required value={form.first} onChange={handle('first')} />
                  <input type="text" placeholder="Last name" className="input" required value={form.last} onChange={handle('last')} />
                </div>
                <input type="email" placeholder="Your email" className="input" required value={form.email} onChange={handle('email')} />
                <input type="tel" placeholder="Phone number" className="input" value={form.phone} onChange={handle('phone')} />
                <textarea rows="4" placeholder="How can we help?" className="input resize-none" required value={form.message} onChange={handle('message')} />

                {status.state === 'error' && (
                  <p className="text-sm text-red-700 bg-red-50 border border-red-200 p-3 rounded">
                    {status.message}
                  </p>
                )}

                <button type="submit" disabled={status.state === 'sending'} className="btn-primary w-full disabled:opacity-50 disabled:cursor-not-allowed">
                  {status.state === 'sending' ? 'Sending…' : 'Submit'}
                </button>

                <p className="text-xs text-gray-400 text-center">
                  By contacting us, you agree to our{' '}
                  <Link to="/terms" className="underline">Terms of Use</Link> and{' '}
                  <Link to="/privacy" className="underline">Privacy Policy</Link>.
                </p>
              </form>
            )}
          </div>
        </div>
      </section>
    </>
  );
}
